import {
    FETCH_MILES,
    FETCH_MILES_SUCCESS,
    FETCH_MILES_FAILED,
    TRANSFER_MILES_SUCCESS,
    TRANSFER_MILES,
    TRANSFER_MILES_FAILED, RESET_TRANSFER_STATUS,
    FETCH_AIRTIME_STOCK,
    FETCH_AIRTIME_STOCK_SUCCESS,
    FETCH_AIRTIME_STOCK_FAILED,
    REDEEM_AIRTIME,
    REDEEM_AIRTIME_SUCCESS,
    REDEEM_AIRTIME_FAILED,
    RESET_AIRTIME_STATUS,
    DONATE_MILES,
    DONATE_MILES_SUCCESS,
    DONATE_MILES_FAILED,
    RESET_DONATE_STATUS,
} from '../store/types';

const INITIAL_STATE = {
    miles: null,
    loading: false,
    transferStatus: null,
    transferring: false,
    transferError: null,
    airtimeStock: null,          // { provider: { value: { available, used } } }
    airtimeStockLoading: false,
    airtimeStockError: null,
    airtimeStatus: null,         // null | 'loading' | 'success' | 'failed'
    airtimeResult: null,         // { provider, value, code, milesDeducted, smsSent }
    airtimeError: null,          // { code, message, details }
    donateStatus: null,          // null | 'loading' | 'success' | 'failed'
    donateResult: null,          // { ngoId, ngo, miles }
    donateError: null,           // { code, message }
    error: { flag: false, msg: null },
};

export const milereducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MILES:
            return {
                ...state,
                loading: true,
                error: { flag: false, msg: null },
            };
        case FETCH_MILES_SUCCESS:
            return {
                ...state,
                miles: action.payload,
                loading: false,
                error: { flag: false, msg: null },
            };
        case FETCH_MILES_FAILED:
            return {
                ...state,
                miles: null,
                loading: false,
                error: { flag: true, msg: action.payload },
            };
        case TRANSFER_MILES:
            return {
                ...state,
                transferring: true,
                transferStatus: null,
                transferError: null,
            };
        case TRANSFER_MILES_SUCCESS:
            return {
                ...state,
                transferring: false,
                transferStatus: 'success',
                transferError: null,
                miles: state.miles || []
            };
        case TRANSFER_MILES_FAILED:
            return {
                ...state,
                transferring: false,
                transferStatus: 'failed',
                transferError: action.payload,
                miles: state.miles || []
            };
        case RESET_TRANSFER_STATUS:
            return {
                ...state,
                transferStatus: null,
                transferring: false,
                transferError: null,
                error: { flag: false, msg: null },
                miles: state.miles || []
            };
        case FETCH_AIRTIME_STOCK:
            return {
                ...state,
                airtimeStockLoading: true,
                airtimeStockError: null,
            };
        case FETCH_AIRTIME_STOCK_SUCCESS:
            return {
                ...state,
                airtimeStock: action.payload,
                airtimeStockLoading: false,
                airtimeStockError: null,
            };
        case FETCH_AIRTIME_STOCK_FAILED:
            return {
                ...state,
                airtimeStockLoading: false,
                airtimeStockError: action.payload,
            };
        case REDEEM_AIRTIME:
            return {
                ...state,
                airtimeStatus: 'loading',
                airtimeResult: null,
                airtimeError: null,
            };
        case REDEEM_AIRTIME_SUCCESS:
            return {
                ...state,
                airtimeStatus: 'success',
                airtimeResult: action.payload,
                airtimeError: null,
            };
        case REDEEM_AIRTIME_FAILED:
            return {
                ...state,
                airtimeStatus: 'failed',
                airtimeResult: null,
                airtimeError: action.payload,
            };
        case RESET_AIRTIME_STATUS:
            return {
                ...state,
                airtimeStatus: null,
                airtimeResult: null,
                airtimeError: null,
            };
        case DONATE_MILES:
            return {
                ...state,
                donateStatus: 'loading',
                donateResult: null,
                donateError: null,
            };
        case DONATE_MILES_SUCCESS:
            return {
                ...state,
                donateStatus: 'success',
                donateResult: action.payload,
                donateError: null,
            };
        case DONATE_MILES_FAILED:
            return {
                ...state,
                donateStatus: 'failed',
                donateResult: null,
                donateError: action.payload,
            };
        case RESET_DONATE_STATUS:
            return {
                ...state,
                donateStatus: null,
                donateResult: null,
                donateError: null,
            };
        default:
            return state;
    }
};
